import React from "react";
import { Link } from "react-router-dom";
import ServiceCard from "./ServiceCard";

const Services = () => {
  const services = [
    {
      id: 1,
      title: "Facility Management & Support Services",
      image: "/images/services/janitorial_service.jpg",
      description: "Comprehensive facilities operations and maintenance for federal buildings.",
      link: "/services/facilities"
    },
    {
      id: 2,
      title: "IT & Technology Services",
      image: "/images/services/IT_services.jpg",
      description: "Modern IT solutions and cybersecurity for government agencies.",
      link: "/services/technology"
    },
    {
      id: 3,
      title: "Emergency Response",
      image: "/images/services/emergency_response.jpg",
      description: "Rapid disaster response and debris removal services.",
      link: "/services/emergency"
    },
    {
      id: 4,
      title: "Logistics & Groundskeeping",
      image: "/images/services/distribution_service.jpg",
      description: "Transportation, logistics, and grounds maintenance services.",
      link: "/services/logistics"
    },
    {
      id: 5,
      title: "Laundry & Linen Services",
      image: "/images/services/laundry_service.jpg",
      description: "High-compliance laundry services for medical facilities.",
      link: "/services/laundry"
    }
  ];

  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        {/* En-tête simple */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2C3E50] mb-4" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            Core Capabilities
          </h2>
          <p className="text-gray-600 max-w-3xl mx-auto">
            We provide mission-critical support across facility operations, technology, logistics, and emergency response—delivered with compliance, efficiency, and operational excellence.
          </p>
        </div>

        {/* Grid Service Categories */}
        
        <div className="space-y-8">
          {/* First row */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.slice(0, 3).map((service) => (
              <ServiceCard key={service.id} service={service} />
            ))}
          </div>

          {/* Second row */}
          <div className="flex justify-center">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 w-full lg:max-w-4xl">
              {services.slice(3).map((service) => (
                <ServiceCard key={service.id} service={service} />
              ))}
            </div>
          </div>
        </div>

        {/* CTA simple */}
        <div className="mt-16 text-center">
          <Link
            to="/contact"
            className="inline-flex items-center px-8 py-3 bg-[#C5A047] text-white rounded-full font-semibold hover:bg-[#D4AF37] transition-all duration-300 shadow-md hover:shadow-lg"
          >
            Contact Our Team
            <svg className="ml-3 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
            </svg>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Services;